import { Analytics } from './analytics'

export enum BillingAnalyticsEvent {
   portalSessionOpened = 'Portal session opened',
}

/**
 * Where the user opened the hosted Chargebee portal from, one value per entry point on the Billing page; the
 * product tracking plan must list the same values. 'team_members_seat_limit' is reserved — the seat-limit flow
 * currently opens the in-app plan picker, not the portal, so nothing fires it yet.
 */
export type BillingPortalSource = 'manage_billing' | 'view_invoices' | 'manage_seats' | 'team_members_seat_limit'

/** Which portal screen the session deep-links to ('invoices' covers the billing-history section). */
export type BillingPortalInitialSection = 'overview' | 'seats' | 'invoices' | 'subscription'

export default class BillingAnalytics implements Analytics {
   static portalSessionOpened = (params: { source: BillingPortalSource; initialSection: BillingPortalInitialSection }) => {
      return Analytics.emitEvent(BillingAnalyticsEvent.portalSessionOpened, {
         'Source': params.source,
         'Initial section': params.initialSection,
      })
   }
}
